import React, {createRef, RefObject} from 'react'

import PopoverSelector from "../../../../core/gd-components/selector/popover-selector/popover-selector"
import {PopoverMenuItemType} from "../../../../core/gd-components/popover-menu/popover-menu/const";
import {SpaceProto} from "../../../../core/model2/space/space-proto";
import PopoverSelectorNew from "../../../../core/gd-components/selector/popover-selector/popover-selector-new";
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../core/gd-components/buttons/control-button/control-button-standard";
import FormToggle from "../../../../core/gd-form/form-element/toggle-new/toggle";
import {EVENT_BUS_MENU_RERENDER} from "../../sections/const";
import {ControlButtonSize} from "../../../../core/gd-components/buttons/control-button/@types";
import ProjectSession from "../../../../core/model2/project/project-session";
import NavigationMenu_ProjectsLocalSettings from "../../local-settings";

export enum ProjectsTreeSortType {
    MANUAL          = 'default',        // manual ???
    ALPHABETICAL    = 'alphabetical',
}

type Props = {

    space                   : SpaceProto
    localSettings?          : NavigationMenu_ProjectsLocalSettings

    // value                 : ProjectsTreeSortType

    className?              : string

    onChange?               : callback
    onReset?                : callback
}

// const debug = "NavigationMenu_SpacePreferences"
const debug = false

export default function NavigationMenu_SpacePreferences(props: Props) {

    const popoverSelectorRef: RefObject<PopoverSelector> = createRef<PopoverSelector>()

    const setManual = () => {
        props.space.projectsSorting = ProjectsTreeSortType.MANUAL

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const setAlphabetical = () => {
        props.space.projectsSorting = ProjectsTreeSortType.ALPHABETICAL

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onSortDefaultReset = () => {
        // debug && console.log(debug, 'onSortDefaultReset')
        // gd.user.menu.projectsAll.sortedMap = {}
        // gd.user.menu.save()

        // this.forceUpdate()

        props.space.resetSortedMap()
        props.onReset?.()
    }

    const onColorizeChange = (value:boolean) => {

        // gd.user.settings.menu.projectsColorize = value
        // gd.user.settings.menu.save()
        props.space.projectsColorize = value

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onCollapseAll = ()=> {

        if (props.localSettings) {
            props.localSettings['expandedProjects'] = [];
            props.localSettings.save()
        }

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onExpandAll = ()=> {

        const recursiveExpand = (project:ProjectSession) => {

            if (props.localSettings && !props.localSettings['expandedProjects'].includes(project.id)) {
                props.localSettings['expandedProjects'].push(project.id);
                props.localSettings.save()
            }

            _.map(project.treeChildren, (childProject: ProjectSession) => {
                recursiveExpand(childProject)
            })
        }

        _.map(props.space.rootProjects, (project: ProjectSession) => {
            recursiveExpand(project)
        })

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    debug && console.log(debug, "space=", props.space)
    debug && console.log(debug, "projectsSorting=", props.space.projectsSorting, "projectsColorize", props.space.projectsColorize)

    let options: Option[] = [
        {
            icon        : 'i5-az-sort',
            value       : ProjectsTreeSortType.ALPHABETICAL,
            label       : "A - Z",
            helpMessage : 'Order projects alphabetically',
            isSelected  : props.space.projectsSorting === ProjectsTreeSortType.ALPHABETICAL,
            onClick     : setAlphabetical
        },
        {
            icon        : 'i5-manual-sort',
            value       : ProjectsTreeSortType.MANUAL,
            label       : 'Manual',
            helpMessage : 'Drag and drop to reorder projects manually',
            isSelected  : props.space.projectsSorting === ProjectsTreeSortType.MANUAL,
            onClick     : setManual
        },
        {
            icon        : 'i5-reset',
            label       : "Reset manual sorting",
            onClick     : onSortDefaultReset,
            disabled    : props.space.projectsSorting === ProjectsTreeSortType.ALPHABETICAL,
            helpMessage : 'Reset sorting to default'
        }
    ]

    // Vozmojno v budushim uslovno dobavlyaetsya?!
    //props.onReset
    // if (true) {
    //     options.push({
    //         icon        : 'i5-reset',
    //         label       : "Reset manual sorting",
    //         onClick     : onSortDefaultReset,
    //         // onClick     : ()=>{
    //         //     props.onReset?.()
    //         //     popoverSelectorRef.current?.hidePopover()
    //         // },
    //         disabled    : props.space.projectsSorting === ProjectsTreeSortType.ALPHABETICAL,
    //         helpMessage : 'Reset sorting to default'
    //     })
    // }

    options = options.concat([
            {
                type        : PopoverMenuItemType.COMPONENT,
                component   : () => {
                    return (
                        <div className="option fl-jsb">
                            <div className="label">Icon Color</div>
                            <FormToggle size="16" value={props.space.projectsColorize} onChange={onColorizeChange}/>
                        </div>
                    )
                },
                helpMessage : 'Colorize project/folder icons'
            },
            {
                type        : PopoverMenuItemType.SEPARATOR
            },
            {
                icon        : 'i5-collapse',
                value       : true,
                label       : 'Collapse all',
                helpMessage : '',
                onClick     : onCollapseAll
            },
            {
                icon        : 'i5-expand',
                value       : false,
                label       : 'Expand all',
                helpMessage : '',
                onClick     : onExpandAll
            },
    ])

    return (
        <PopoverSelectorNew
            button={
                (isSelected:boolean, onClick:callback)=>{
                    return <ControlButtonStandard type={ControlButtonType.PREFERENCES} isSelected={isSelected} onClick={onClick} size={ControlButtonSize.SIZE_24} className="m-r-3" />
                }
            }
            options={options}
        />
    )


    // return <PopoverSelector ref                 = {popoverSelectorRef}
    //                         className           = {Classes('sort-button', props.className)}
    //                         popoverClassName    = "w-200"
    //                         buttonType          = "control-icon"
    //                         options             = {options}
    //                         hint                = "Sort by"
    //                         value               = {props.value}
    //                         onChange            = {props.onChange}/>
}
